import {normalCdf} from "./normalCdf";

// Sign test
export function PValueMatrix(winMatrix) {
    const N = winMatrix.length;
    const result = Array.from({ length: N }, () => Array(N).fill(null));

    for (let i = 0; i < N; i++) {
        for (let j = 0; j < N; j++) {
            if (i === j) continue;
            const nij = winMatrix[i][j];
            const nji = winMatrix[j][i];
            const n   = nij + nji;
            if (n === 0) continue;
            const z = (nij - n / 2) / Math.sqrt(n / 4);
            result[i][j] = 2 * (1 - normalCdf(Math.abs(z)));
        }
    }

    return result;
}
